import { useContext } from "react";
import { ApiContext } from "../../../contexts/api/context";
import { useWhoAmIQuery } from "../../../services/api/__generated__/backend_gateway-types";
import { GoodchopGrossOdlGenerationComponent } from "./component";

export const GoodchopGrossOdlGenerationContainer = () => {
  const { apiService } = useContext(ApiContext);

  const { loading, error } = useWhoAmIQuery({
    client: apiService.getClient(),
  });

  if (error) {
    console.error(
      "GoodchopGrossOdlGenerationContainer: useWhoAmIQuery fetch error",
      error
    );
  }

  return <GoodchopGrossOdlGenerationComponent loading={loading} />;
};
